import { WarningCircle } from "@/components/shared/icons";
import { View } from "@/components/ui";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
} from "@/components/ui/dropdown-menu";
import { Link } from "@/components/shared/link";
import { generateWALink } from "@/lib/helpers/string";
import { Typography } from "@/components/shared/typography";
import { SALES_NUMBER } from "@/constants";

const waLink = generateWALink(
  SALES_NUMBER,
  "Hi! I would like to speak to sales about booking a new appointment for Home Cleaning service",
);

export const InfoHelper = () => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger>
        <View className="cursor-pointer">
          <WarningCircle
            size={16}
            className="scale-y-[-1] transform text-foreground-intermediate"
          />
        </View>
      </DropdownMenuTrigger>

      <DropdownMenuContent className="-left-10 p-2 px-3">
        <View className="max-w-[311px]">
          <Typography variant="body-sm">
            Did you know? If your referrals earn you more than $200 in account
            credit, you can cash it out! Contact us at
            <Link
              href={waLink}
              className="text-primary"
              target="_blank"
            >{` ${SALES_NUMBER} `}</Link>
            to learn more
          </Typography>
        </View>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
